import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Close = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M25.333 8.547l-1.88-1.88-7.453 7.453-7.453-7.453-1.88 1.88 7.453 7.453-7.453 7.453 1.88 1.88 7.453-7.453 7.453 7.453 1.88-1.88-7.453-7.453z"></path>
  </SvgIcon>
);

export default Close;
